// extracted by mini-css-extract-plugin
module.exports = {"footer1":"footer_footer1__m_R1T","footerInner":"footer_footerInner__Kiyh9","copyright":"footer_copyright__328Gf"};